import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=3906858f&scoped=true&"
import script from "./qualification.vue?vue&type=script&lang=js&"
export * from "./qualification.vue?vue&type=script&lang=js&"
import style0 from "./qualification.vue?vue&type=style&index=0&id=3906858f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906858f",
  null
  
)

export default component.exports